<template>
  <sui-page>
    <sui-page-header
      :pageId="this.$options.name"
    />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_B2B_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.b2bId"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EMPL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.userName"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY_CD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.companyCode"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.companyName"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACC_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="userAccountPossessionYn"
              :selected="searchFrame.selectedCodeValue.userAccountPossessionYn"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACC_STATUS')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="userAccountStateCode"
              :selected="searchFrame.selectedCodeValue.userAccountStateCode"
              defaultOption="all"
              codeId="COD_USR_ACO_STT"
              :initialSelectedKey="'1'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MAIL_ADDR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.email"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="userRealUseYn"
              :selected="searchFrame.selectedCodeValue.userRealUseYn"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-3" />
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :showCountControl="true"
        :showDisplayCountControl="false"
        :initialPagesize="10"
        :columns="gridColumns0"
        :dataset="'ds0'"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="this.$options.name"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onExcelDownloadClick"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <sui-popup
        v-model="isShownPopupDetail"
        :title="$t('MSG_TIT_PEHS_USR_MGT')"
      >
        <p01
          :pageId="this.$options.name"
          :userId="selectedB2BId"
          @onDetailAndCancelClick="onDetailAndCancelClick"
          @research="research"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import p01 from './components/PGE_CMY_00032_P01';
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00032', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      searchFrame: {
        b2bId: '',
        userName: '',
        companyCode: '',
        companyName: '',
        email: '',
        selectedCodeValue: {
          userAccountPossessionYn: {
            key: '',
            label: '',
          },
          userAccountStateCode: {
            key: '',
            label: '',
          },
          userRealUseYn: {
            key: '',
            label: '',
          },
        },
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_B2B_ID'),
        datafield: 'b2bId',
      }, {
        text: this.$t('MSG_TXT_EMPL_NM'),
        datafield: 'userName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 120,
      }, {
        text: this.$t('MSG_TXT_EMPL_NM_GLBL'),
        datafield: 'userGlobalName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_EMAIL'),
        datafield: 'email',
      }, {
        text: this.$t('MSG_TXT_CPNY_CD'),
        datafield: 'companyCode',
      }, {
        text: this.$t('MSG_TXT_CPNY_NM'),
        datafield: 'companyName',
      }, {
        text: this.$t('MSG_TXT_ACC_USE_YN'),
        datafield: 'userAccountPossessionYn',
      }, {
        text: this.$t('MSG_TXT_ACC_STATUS'),
        datafield: 'userAccountStateName',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'userRealUseYn',
      }],
      isShownPopupDetail: false,
      selectedB2BId: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'b2bId', map: 'b2bId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'companyCode', map: 'companyCode' },
      { type: 'string', name: 'companyName', map: 'companyName' },
      { type: 'string', name: 'userAccountPossessionYn', map: 'userAccountPossessionYn' },
      { type: 'string', name: 'userAccountStateCode', map: 'userAccountStateCode' },
      { type: 'string', name: 'userAccountStateName', map: 'userAccountStateName' },
      { type: 'string', name: 'userRealUseYn', map: 'userRealUseYn' },
      { type: 'string', name: 'email', map: 'email' },
    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onResetClick() {
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          this.$refs.userAccountPossessionYn.reset();
          this.$refs.userAccountStateCode.reset();
          this.$refs.userRealUseYn.reset();
        } else {
          this.searchFrame[key] = '';
        }
      });
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    onSearchClick() {
      const searchData = this.getSearchData();

      http.request(this.$options.name, 'DTS_CMY_00085', {
        query: searchData,
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onGridSingleButtonClicked(value, dataRow) {
      this.onDetailAndCancelClick(dataRow.b2bId);
    },
    onDetailAndCancelClick(b2bId) {
      this.selectedB2BId = utils.isEmpty(b2bId) ? '' : b2bId;
      this.isShownPopupDetail = !this.isShownPopupDetail;
    },
    onExcelDownloadClick() {
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `pehsUserList_${sToday}.xlsx`;
      utils.downloadGridToExcel(this.$options.name, this.gridColumns0, this.ds0, sExcelName);
    },
    research() {
      this.onDetailAndCancelClick();
      this.onSearchClick();
    },
  },
};
</script>
<style scoped>
</style>
